const pad2 = (n) => String(n).padStart(2, '0');

/** Current local value for `<input type="datetime-local" />`. */
export const nowDatetimeLocal = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}T${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
};

/** Current local value for `<input type="date" />`. */
export const nowDateLocal = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
};

/** Local calendar date for `<input type="date" />` (avoids UTC shift from `toISOString`). */
export const toDateInputValue = (date) => {
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
};

/** First day of the current month in local time. */
export const startOfMonthDateLocal = () => {
  const d = new Date();
  return toDateInputValue(new Date(d.getFullYear(), d.getMonth(), 1));
};

/** Parse API / DB datetime string into `datetime-local` value. */
export const toDatetimeLocalFromApi = (value) => {
  if (value == null || value === '') return '';
  const d = new Date(String(value).trim().replace(' ', 'T'));
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}T${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
};

export const isBeforeMinDatetime = (value, minValue) =>
  Boolean(value && minValue && value < minValue);

export const isBeforeMinDate = (value, minValue) =>
  Boolean(value && minValue && value < minValue);

/** Never return a datetime-local value before `min` (defaults to now). */
export const clampDatetimeLocal = (value, min) => {
  const floor = min || nowDatetimeLocal();
  if (!value || isBeforeMinDatetime(value, floor)) return floor;
  return value;
};

/** Never return a date input value before `min` (defaults to today). */
export const clampDateLocal = (value, min) => {
  const floor = min || nowDateLocal();
  if (!value || isBeforeMinDate(value, floor)) return floor;
  return value;
};

/** End time must be >= start and >= now. */
export const getMinEndDatetimeLocal = (startValue) => {
  const now = nowDatetimeLocal();
  if (!startValue) return now;
  return startValue < now ? now : startValue;
};

export const createFutureDatetimeChangeHandler = (onChange, minDatetime) => (event) => {
  const floor = minDatetime || nowDatetimeLocal();
  const next = clampDatetimeLocal(event.target.value, floor);
  onChange(next);
};

export const createFutureDateChangeHandler = (onChange, minDate) => (event) => {
  const floor = minDate || nowDateLocal();
  const next = clampDateLocal(event.target.value, floor);
  onChange(next);
};

export const getFutureDatetimeInputProps = (minDatetime, extra = {}) => ({
  min: minDatetime || nowDatetimeLocal(),
  ...extra,
});

export const getFutureDateInputProps = (minDate, extra = {}) => ({
  min: minDate || nowDateLocal(),
  ...extra,
});

/** `datetime-local` → `YYYY-MM-DD HH:mm:ss` for API form bodies. */
export const toApiDatetimeFromLocal = (localValue) => {
  if (!localValue) return '';
  const [datePart, timePart] = localValue.split('T');
  if (!datePart || !timePart) return String(localValue).replace('T', ' ');
  const [hh, mm] = timePart.split(':');
  return `${datePart} ${hh}:${mm}:00`;
};

export const FUTURE_DATETIME_HELPER =
  'Past date and time cannot be selected.';

export const FUTURE_DATE_HELPER = 'Past dates cannot be selected.';
